"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateMonth = void 0;
var DateMonth;
(function (DateMonth) {
    DateMonth[DateMonth["January"] = 0] = "January";
    DateMonth[DateMonth["February"] = 1] = "February";
    DateMonth[DateMonth["March"] = 2] = "March";
    DateMonth[DateMonth["April"] = 3] = "April";
    DateMonth[DateMonth["May"] = 4] = "May";
    DateMonth[DateMonth["June"] = 5] = "June";
    DateMonth[DateMonth["July"] = 6] = "July";
    DateMonth[DateMonth["August"] = 7] = "August";
    DateMonth[DateMonth["September"] = 8] = "September";
    DateMonth[DateMonth["October"] = 9] = "October";
    DateMonth[DateMonth["November"] = 10] = "November";
    DateMonth[DateMonth["December"] = 11] = "December";
})(DateMonth || (exports.DateMonth = DateMonth = {}));
